import type { RouteLocationRaw } from 'vue-router'

import { useMarketBaseUrl } from '@backmarket/nuxt-module-marketplace/useMarketBaseUrl'

import type { PaymentFlow } from '../config/flows'
import { type PaymentRouteParams, buildPaymentRoute } from '../config/routes'

import { useIsPaymentDomainEnabled } from './useIsPaymentDomainEnabled'

/**
 * Get the location of a payment page based on the flow and parameters.
 * If the payment domain is enabled the function will return an absolute URL to the payment page.
 * If the payment domain is not enabled the function will return the legacy fallback argument.
 */
export const usePaymentRouteLocation = <Flow extends PaymentFlow>(
  flow: Flow,
) => {
  const isPaymentDomainEnabled = useIsPaymentDomainEnabled(flow)
  const { baseUrlWithLocale: paymentSiteUrl } = useMarketBaseUrl('payment')

  return (
    params: PaymentRouteParams<Flow>,
    legacyFallback?: RouteLocationRaw,
  ): RouteLocationRaw | undefined => {
    if (isPaymentDomainEnabled.value) {
      return `${paymentSiteUrl}/${buildPaymentRoute(flow, params)}`
    }

    return legacyFallback
  }
}
